// src/components/resumo/layout/AutoHideHeader.tsx
import React, { useEffect, useState, forwardRef } from 'react';
import './AutoHideHeader.css';

interface AutoHideHeaderProps {
    children: React.ReactNode;
    darkMode?: boolean;
    threshold?: number;
}

const AutoHideHeader = forwardRef<HTMLDivElement, AutoHideHeaderProps>(
    ({ children, darkMode = false }, ref) => {
        const [isVisible, setIsVisible] = useState(true);

        useEffect(() => {
            let lastScrollY = 0;
            let ticking = false;

            const handleScroll = (e?: Event) => {
                if (!ticking) {
                    window.requestAnimationFrame(() => {
                        // ✅ Detectar qual elemento está fazendo scroll
                        const scrollContainer = document.getElementById('rrp-scroll-container');
                        const isFullscreen = !!document.fullscreenElement;

                        const scrollY = isFullscreen && scrollContainer
                            ? scrollContainer.scrollTop
                            : window.scrollY;

                        if (scrollY > lastScrollY && scrollY > 100) {
                            setIsVisible(false);
                        } else if (scrollY < lastScrollY) {
                            setIsVisible(true);
                        }

                        if (scrollY < 50) {
                            setIsVisible(true);
                        }

                        lastScrollY = scrollY;
                        ticking = false;
                    });

                    ticking = true;
                }
            };

            // ✅ Listeners em múltiplos elementos
            window.addEventListener('scroll', handleScroll, { passive: true });

            const scrollContainer = document.getElementById('rrp-scroll-container');
            if (scrollContainer) {
                scrollContainer.addEventListener('scroll', handleScroll, { passive: true });
            }

            return () => {
                window.removeEventListener('scroll', handleScroll);
                if (scrollContainer) {
                    scrollContainer.removeEventListener('scroll', handleScroll);
                }
            };
        }, []);

        // ✅ RETORNO JSX (mínimo)
        return (
            <div
                ref={ref}
                className={`auto-hide-header ${isVisible ? 'visible' : 'hidden'} ${darkMode ? 'dark' : ''}`}
            >
                {children}
            </div>
        );
    }
);

// ✅ displayName fora do componente
AutoHideHeader.displayName = 'AutoHideHeader';

// ✅ export fora do componente
export default AutoHideHeader;